import { useEffect, useState } from 'react'

import { ResponseContext } from '@cash-web/protos/squareup/franklin/ResponseContextProto.pb'
import { clearContext, onResponseContextSet } from '@cash-web/shared-util-fetch'

export const useResponseContext = () => {
  const [responseContext, setResponseContext] = useState<ResponseContext | undefined>()
  useEffect(() => onResponseContextSet(setResponseContext), [setResponseContext])
  return { responseContext, clearContext }
}
